<template>
    <AclLayout>
        <el-card>
            <InertiaLink href="/acl/users" class="block w-full mb-3">
                <el-button size="small" class="w-full">Вернуться назад</el-button>
            </InertiaLink>

            <ElDivider />

            <el-form :model="form" @submit.prevent="submit">
                <el-form-item label="Фамилия" :error="errors.last_name">
                    <el-input v-model="form.last_name" />
                </el-form-item>
                <el-form-item label="Имя" :error="errors.first_name">
                    <el-input v-model="form.first_name" />
                </el-form-item>
                <el-form-item label="Отчество" :error="errors.second_name">
                    <el-input v-model="form.second_name" />
                </el-form-item>

                <el-form-item label="E-Mail" :error="errors.email">
                    <el-input v-model="form.email" type="email" />
                </el-form-item>

                <el-collapse accordion class="mb-3">
                    <el-collapse-item title="Привязанные профили" class="px-2">
                        <div
                            v-for="(entry, entryIndex) in form.integrations"
                            :key="entryIndex"
                            class="flex border rounded p-2.5"
                        >
                            <div class="flex-auto w-3/5 mr-4">
                                <el-select v-model="entry.service" required>
                                    <el-option value="crm">CRM</el-option>
                                    <el-option value="mattermost">Mattermost</el-option>
                                </el-select>
                                <el-input
                                    v-model="entry.value"
                                    type="input"
                                    placeholder="00"
                                    required
                                />
                            </div>

                            <el-button
                                class="flex-initial ml-auto"
                                type="danger"
                                native-type="button"
                                size="small"
                                required
                                @click="removeIntegration(entryIndex)"
                            >
                                &times;
                            </el-button>
                        </div>

                        <div class="mt-2">
                            <el-button
                                class="w-full"
                                type="primary"
                                native-type="button"
                                @click="addNewIntegration"
                            >
                                &plus; Добавить
                            </el-button>
                        </div>
                    </el-collapse-item>
                </el-collapse>

                <el-form-item label="Группа" :error="errors.groups">
                    <el-select v-model="form.groups" multiple class="w-full">
                        <el-option
                            v-for="group in groups"
                            :key="group.id"
                            :label="group.name"
                            :value="group.id"
                        ></el-option>
                    </el-select>
                </el-form-item>

                <el-form-item class="text-center -mx-2">
                    <el-button type="primary" class="mx-1" @click="submit">Сохранить</el-button>

                    <InertiaLink :href="'/acl/users/'" class="inline-block mx-1">
                        <el-button>Отменить</el-button>
                    </InertiaLink>
                </el-form-item>
            </el-form>
        </el-card>
    </AclLayout>
</template>

<script>
import { defineComponent } from "vue"
import AclLayout from "@/js/Layouts/Acl.vue"

export default defineComponent({
    name: "GroupPage",
    components: { AclLayout },
    props: {
        user: {
            type: Object,
            required: false,
            default: () => {},
        },
        userGroups: {
            type: Array,
            required: false,
            default: () => [],
        },
        groups: {
            type: Object,
            required: true,
        },
        errors: {
            type: Object,
            default: () => {},
        },
    },
    data: () => ({
        form: {
            first_name: "",
            last_name: "",
            second_name: "",
            email: "",
            groups: [],
            integrations: [],
        },
    }),
    computed: {
        isEditMode() {
            return !!this.user
        },
    },
    beforeMount() {
        if (this.isEditMode) {
            for (const key in this.form) {
                if (this.user[key]) {
                    this.form[key] = this.user[key]
                }
            }

            this.form.groups = this.userGroups || []
        }
    },
    methods: {
        submit() {
            if (this.isEditMode) {
                this.$inertia.put("/acl/users/" + this.user.id, this.form)
            } else {
                this.$inertia.post("/acl/users", this.form)
            }
        },
        addNewIntegration() {
            this.form.integrations.push({ service: null, value: "" })
        },
        removeIntegration(indexForDelete) {
            this.form.integrations = this.form.integrations?.filter(
                (_item, index) => index !== indexForDelete,
            )
        },
    },
})
</script>
